import { Avatar, Stack } from '@mui/material';
import { initials } from '../lib/text';

/** Round initials, then the name: the first column of the customer and agent tables */
export const NameCell = ({ name }: { name: string }) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
    <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: 'primary.main' }}>{initials(name)}</Avatar>
    <span>{name}</span>
  </Stack>
);
